module.exports = __webpack_public_path__ + "static/media/greenFlag.ea23d07d.png";